export * from './enums'

export const RUN_ON_PAGE_UPLOAD_MESSAGE_STANDARD = 'Process a page uploaded to a gallery'
export const RUN_ON_PAGE_UPLOAD_MESSAGE_SHORT = 'Run on page upload'
export const RUN_ON_PAGE_UPLOAD_MESSAGE_HELP = "The model will process each image uploaded to the session's gallery."
